<template>
  <div>
    <div class="container mb-10">
      <div id="title-div">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-sm-1">
              <button type="button" class="btn btn-primary" @click="back()">
                Back
              </button>
            </div>
            <div class="col-sm-4"></div>
            <div class="col-sm-3">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label page-title fw-bolder fs-3 mb-1">
                  Customer {{ pybNumber }}</span
                >
              </h3>
            </div>
            <div class="col-sm-4 align-self-end text-right">
              <button
                type="button"
                class="btn btn-danger"
                @click="deleteCustomer()"
              >
                Delete Customer
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="spacer-y-10"></div>
      <div class="row">
        <div class="col-sm-6">
          <div class="sectionbreak mb-2">
            <span class="badge badge-light-success mr-3">Email</span
            ><!--end::Svg Icon--><span class="fs-5 fw-bold">{{ email }}</span>
          </div>
          <div class="sectionbreak mb-2">
            <span class="badge badge-light-success mr-3">Status</span
            ><!--end::Svg Icon--><span class="fs-5 fw-bold">{{ status }}</span>
          </div>
          <div class="sectionbreak mb-2">
            <span class="badge badge-light-success mr-3">Sign Up Date</span
            ><!--end::Svg Icon--><span class="fs-5 fw-bold">{{
              formattedDate(signUpDate)
            }}</span>
          </div>
        </div>
      </div>
      <div class="spacer-y-10"></div>

      <div class="card">
        <div class="card-body py-10">
          <div class="row">
            <div class="col-sm-6">
              <div class="fv-plugins-icon-container">
                <label class="d-flex align-items-center fs-5 fw-bold"
                  ><span class="required">First Name</span></label
                ><input
                  type="text"
                  class="form-control form-control-lg form-control-solid"
                  v-model="firstName"
                />
                <div
                  class="fv-plugins-message-container invalid-feedback"
                ></div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="fv-plugins-icon-container">
                <label class="d-flex align-items-center fs-5 fw-bold"
                  ><span class="required">Last Name</span></label
                ><input
                  type="text"
                  class="form-control form-control-lg form-control-solid"
                  v-model="lastName"
                />
                <div
                  class="fv-plugins-message-container invalid-feedback"
                ></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3"></div>
            <div class="col-sm-6">
              <div class="fv-plugins-icon-container">
                <label class="d-flex align-items-center fs-5 fw-bold"
                  ><span class="required">Phone</span></label
                >
                <input
                  type="text"
                  class="form-control form-control-lg form-control-solid"
                  v-model="phoneNumberInput"
                  @focus="phoneNumberOnFocus = true"
                  @blur="phoneNumberOnFocus = false"
                  @keypress="filterGivenPhoneNumber($event, phoneNumberInput)"
                  placeholder=""
                  inputmode="numeric"
                />
                <div
                  class="error-text"
                  v-if="!$v.phone.required && $v.phone.$dirty"
                >
                  Phone number is required
                </div>
              </div>
            </div>
            <div class="col-sm-3"></div>
          </div>
          <br />
          <hr class="mb-0" style="background-color: black; height: 2px" />
          <br />
          <div class="row">
            <h3>Additional Fields</h3>
            <AdditionalFields v-model="additionalFieldsArray" />
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button
                :disabled="!this.formValid || this.loading"
                type="button"
                :class="saveButtonClass"
                @click="updateCustomer()"
              >
                Save
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-md align-middle ms-2"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="confirmationAccept"
      @eCancel="confirmationReject"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import { error } from "@/services/LoggerService";
import { ApiService } from "@/services/ApiService";
import { required } from "vuelidate/lib/validators";
import mixins from "vue-typed-mixins";
import FieldValidationMixin from "@/mixins/FieldValidationMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import AdditionalFields from "@/components/AdditionalFields.vue";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import dayjs from "dayjs";

export default mixins(
  ConfirmationModalMixin,
  SnackbarNotifierMixin,
  FieldValidationMixin
).extend({
  name: "ViewCustomer",
  components: {
    SnackbarNotifier,
    AdditionalFields,
    ConfirmationModal,
  },
  data() {
    return {
      loading: false,
      pybNumber: "",
      firstName: "",
      lastName: "",
      email: "",
      signUpDate: "",
      status: "",
      phone: "",
      additionalFieldsArray: [],
      phoneNumberOnFocus: false,
    };
  },
  validations: {
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    phone: {
      required,
    },
  },
  computed: {
    phoneNumberInput: {
      get() {
        try {
          if (!this.phoneNumberOnFocus) {
            return this.phone;
          }
          return this._countDigits(this.phone).digits;
        } catch (e) {
          error(e);
        }
        return "";
      },
      set(value) {
        this.phone = this.phoneNumberFormatting(value);
      },
    },
    saveButtonClass() {
      const defaultClass = "btn fw-bold px-6 py-5 w-100 mb-4 mt-6";
      if (!this.formValid || this.loading)
        return `${defaultClass} btn-secondary disabled`;
      return `${defaultClass} btn-primary`;
    },
  },
  methods: {
    formValid() {
      return !this.$v.$invalid;
    },
    formattedDate(date) {
      try {
        return dayjs(date).format("MMM D, YYYY");
      } catch (e) {
        error(e);
      }
      return "";
    },
    back() {
      this.$router.push({ name: "Admin", hash: "#manageCustomer" });
    },
    objectToArray(obj) {
      if(!obj){
        return [];
      }
      return Object.keys(obj).map((k) => {
        return {
          key: k,
          value: obj[k],
        };
      });
    },
    arrayToObject(arr) {
      return arr.reduce((itemObject, item) => {
        itemObject[item.key] = item.value;
        return itemObject;
      }, {});
    },
    async deleteCustomer() {
      try {
        if (!this.formValid()) {
          return;
        }

        const shouldDeleteCustomer = await this.confirm();
        this.stopConfirmationLoading();
        if (!shouldDeleteCustomer) {
          return;
        }
        this.loading = true;

        await ApiService.Instance.deleteCustomer({
          pybNumber: this.pybNumber,
        });

        this.showNotifier({
          message: `Deleted Customer`,
          snackbarType: "success",
        });

        this.$router.push({ name: "Admin", hash: "#manageCustomer" });
      } catch (e) {
        error(e);
        this.showNotifier({
          message: `Failed To Delete Customer`,
          snackbarType: "error",
        });
      }
      this.loading = false;
    },
    async updateCustomer() {
      try {
        if (!this.formValid()) {
          return;
        }

        const shouldUpdateCustomer = await this.confirm();
        this.stopConfirmationLoading();
        if (!shouldUpdateCustomer) {
          return;
        }
        this.loading = true;

        const additionalFieldsObject = this.arrayToObject(this.additionalFieldsArray);

        await ApiService.Instance.updateCustomer({
          pybNumber: this.pybNumber,
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          additionalFields: additionalFieldsObject,
        });

        this.showNotifier({
          message: `Saved Customer Details`,
          snackbarType: "success",
        });
      } catch (e) {
        error(e);
        this.showNotifier({
          message: `Failed To Save Customer Details`,
          snackbarType: "error",
        });
      }
      this.loading = false;
    },
    async getCustomer() {
      try {
        this.loading = true;

        const result = await ApiService.Instance.getCustomer({
          pybNumber: this.pybNumber,
        });

        this.firstName = result.firstName;
        this.lastName = result.lastName;
        this.email = result.email;
        this.signUpDate = result.signUpDate;
        this.status = result.status;
        this.phone = result.phone;
        this.additionalFieldsArray = this.objectToArray(result.additionalFields);
      } catch (e) {
        error(e);
      }
      this.loading = false;
    },
  },
  async beforeMount() {
    try {
      this.pybNumber = this.$route.params.pybNumber;
      await this.getCustomer();
    } catch (e) {
      error(e);
    }
  },
});
</script>

<style lang="scss" scoped>
</style>